export const style = (topSpacing = '20', bottomSpacing = '20') => `
  <style>
    .countdown-timer {
      padding: ${topSpacing}px 20px ${bottomSpacing}px 20px;
      text-align: center;
    }

    .countdown-message {
      padding: 0px 50px 15px 50px;
    }
    
    .countdown-container {
      max-width: 800px;
      margin: 0 auto;
    }
    
    .countdown-display {
      display: flex;
      justify-content: center;
    }
    
    .countdown-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      min-width: 80px;
    }
    
    .countdown-number {
      font-size: 32px;
      font-weight: bold;
      margin-bottom: 5px;
    }
    
    .countdown-label {
      font-size: 14px;
      text-transform: uppercase;
      letter-spacing: 1px;
    }
    
    .countdown-seconds {
      display: flex;
    }
    
    .countdown-separator {
      font-size: 32px;
      font-weight: bold;
      align-self: flex-start;
    }
    
    .countdown-expired {
      font-size: 24px;
      font-weight: bold;
      color: #ff0000;
    }
    
    @media (max-width: 768px) {
      .countdown-number {
        font-size: 28px;
      }
      
      .countdown-separator {
        font-size: 28px;
        margin-top: 15px;
      }
    }
  </style>
`;
